import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.DynamicStepContainer', {
    removeStep: 'Remove this approval step',
    deleteStep: 'Delete step?',
});
